import { Fab, Tooltip } from '@mui/material';
import Iconify from '../../components/Iconify';
import useCollapse3dCode from '../../hooks/useCollapse3dCode';

export default function CardCodeFab() {
  const { onOpenCardCodeReceiver } = useCollapse3dCode();

  return (
    <Tooltip title="3D Payment Codes" arrow placement="right">
      <Fab
        color="primary"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          pt: 1,
          display: 'block',
        }}
        onClick={() => onOpenCardCodeReceiver('karta')}
      >
        <Iconify icon="solar:password-outline" sx={{ width: 30, height: 30 }} />
      </Fab>
    </Tooltip>
  );
}
